import { Grid, Tooltip } from "@material-ui/core";
import GlobitsPagingAutocomplete from "app/common/form/GlobitsPagingAutocomplete";
import GlobitsSelectInput from "app/common/form/GlobitsSelectInput";
import IconClose from "app/common/Icon/IconClose";
import { STATUS_RESULT_PATIENT_ADVISE } from "app/common/LocalConst";
import { getDateTime } from "app/common/LocalFunction";
import { pagingPatientAdvise } from "app/services/PatientAdvice";
import { useStore } from "app/stores";
import { useFormikContext } from "formik";
import IconButton from "@material-ui/core/IconButton";
import React, { useState } from "react";
import { observer } from "mobx-react";
import IconPen from "app/common/Icon/IconPen";
import IconCheck from "app/common/Icon/IconCheck";
import IconLock from "app/common/Icon/IconLock";
import IconDelete from "app/common/Icon/IconDelete";
const HeaderBoxAdvise = observer(
  ({
    patientId,
    handleGetItemAdviseById,
    handleClose,
    handleGetPatientOverviewById,
    handleUpdateItemAdviseStatus,
    // isDeletePermission,
    // isEditPermission,
    currentTabContainer,
  }) => {
    const [editable, setEditabled] = useState(false);
    const { values } = useFormikContext();
    const { handleClearItemPatientAdvise, pagingAdvise } =
      useStore().patientManagementStore.listAdviseStore;
    return (
      <div className="chat-header">
        <Grid container spacing={1} style={{ width: "100%" }}>
          <Grid item xs={5}>
            <GlobitsPagingAutocomplete
              name={"patientAdvice"}
              api={pagingPatientAdvise}
              searchObject={{ patientId }}
              getOptionLabel={(option) => {
                let display = "";
                if (option?.visit) {
                  display = ` ${getDateTime(option?.visit?.startDatetime)}`;
                }
                return display;
              }}
              onChange={(_, value, action) => {
                handleGetItemAdviseById(value?.id);
              }}
            />
          </Grid>
          <Grid item xs={5}>
            <GlobitsSelectInput
              name="result"
              options={STATUS_RESULT_PATIENT_ADVISE}
              disabled={!values?.patientAdvice || !editable}
            />
          </Grid>
          {editable ? (
            <>
              <Grid item xs={1} className="flex align-center  gap-1">
                <Tooltip title="Bỏ cập nhật trạng thái phiếu tư vấn">
                  <div>
                    <span
                      className="flex align-center"
                      onClick={() => {
                        setEditabled((prev) => !prev);
                      }}
                    >
                      <IconLock color="#4276a4" />
                    </span>
                  </div>
                </Tooltip>
                <Tooltip title="Cập nhật trạng thái phiếu tư vấn">
                  <span
                    onClick={async () => {
                      setEditabled((prev) => !prev);
                      handleUpdateItemAdviseStatus(values);
                    }}
                    className="cursor flex flex-center"
                  >
                    <IconCheck color="#4276a4" />
                  </span>
                </Tooltip>
              </Grid>
            </>
          ) : (
            <>
              <Grid item xs={1} className="flex align-center  gap-2">
                <Tooltip title="Sửa trạng thái phiếu tư vấn">
                  <div>
                    <span
                      className="cursor flex align-center"
                      onClick={() => {
                        setEditabled((prev) => !prev);
                      }}
                    >
                      <IconPen color="#4276a4" />
                    </span>
                  </div>
                </Tooltip>
                <Tooltip title="Xóa phiếu tư vấn">
                  <span
                    onClick={async () => {
                      handleClearItemPatientAdvise({
                        ...values?.patientAdvice,
                      });
                    }}
                    className="cursor flex flex-center"
                  >
                    <IconDelete color="red" />
                  </span>
                </Tooltip>
              </Grid>
            </>
          )}

          <IconButton
            aria-label="close"
            onClick={() => {
              handleClose(false);
              handleGetPatientOverviewById(patientId);
              if (currentTabContainer === 1) {
                pagingAdvise();
              }
            }}
            className="chatbox__iconBtn"
          >
            <IconClose className="chatbox__icon" color="#4276a4" />
          </IconButton>
        </Grid>
      </div>
    );
  }
);

export default HeaderBoxAdvise;
